import { render } from "./ConhecimentoEventos.vue?vue&type=template&id=7577c6a0"
import script from "./ConhecimentoEventos.vue?vue&type=script&lang=js"
export * from "./ConhecimentoEventos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__